<template>
<div>
    <div class="main-header">
        <div class="container">
            <h2 class="main-header-text">
                Transaction Confirmation
            </h2>
        </div>
    </div>

    <div class="main-section mgt-40">
        <div class="container">

            <div class="main-card">
                <img src="/static/img/icons/arrow-down-indicator-red.png" alt="" class="top-indicator" />

                <div class="row">

                    <div  class="col-lg-8">

                            <div class="transaction-detail text-center" v-if="vModel.Success">
                                <h2>Thank You!
                                    <br />{{vModel.Message}}
                                </h2>
                                <img src="/static/img/success.png" />

                            </div>

                            <div class="transaction-detail text-center" v-if="!vModel.Success">
                                <h2>
                                    {{vModel.Message}}
                                </h2>
                                <img src="/static/img/fail.png" />
                                <!-- <div class="mt-5">
                                    <span v-html="vModel.Message"></span>
                                </div> -->
                            </div>

                            <div class="submit-option">

                                <div class="right-option">
                                    <router-link :to="'/dashboard'" class="btn submit-righticon-btn">
                                        <span class="btn-content">Home</span>
                                        <span class="right-icon">
                                            <i class="material-icons">chevron_right</i>
                                        </span></router-link>
                                </div>
                            </div>
                        <!-- eo col-8 -->
                    </div>

                    <div class="col-lg-4">
                        <div class="sidebar">
                            <img src="/static/img/icons/arrow-down-indicator-white.png" alt="" class="sidebar-arrow" />

                            <h3 class="sidebar-header">Transfer Summary</h3>

                            <hr />

                            <div class="country-detail">
                                <img :src="'/static/img/flags/'+userInfo.CountryFlag+'.png'" alt="" />
                                <h4>{{userInfo.Name}}
                                    <br />
                                    <span class="country">{{userCountry}}</span>
                                </h4>
                            </div>

                            <hr />

                            <div class="personal-detail">
                                <ul>
                                    <li>
                                        <p>Bank Account Number : </p>
                                        <h4>{{vModel.TransactionDetail.CCNo}}</h4>
                                    </li>
                                    <li>
                                        <p>Bank Name : </p>
                                        <h4>{{vModel.TransactionDetail.CCName}}</h4>
                                    </li>
                                </ul>
                            </div>

                        </div>
                    </div>
                </div>
                <!-- eo row -->

            </div>
            <!-- eo main card -->

        </div>
        <!-- eo container -->
    </div>
    <!-- eo main section -->
</div>
</template>

<script>
import TransactionService from "../../services/transaction";
import commonService from "../../services/common";


export default {
    name: "transactionconfirmationbc",
    created(){
        this.userInfo = commonService.getUserInfo();
        var userDetail = commonService.getUserDetailInformation();
        this.userCountry = userDetail.Country;
    },
    beforeRouteEnter(to, from, next) {
        commonService.removeStorage("transactionRefNo");
        var promises = [];
        var refno = to.params.txnrefno;

      promises.push(TransactionService.getConfirmationBC(refno));
      Promise.all(promises).then(response => {
        next(p => {
          p.vModel = response[0].body;
      })});
    },
    data() {
      return {
        userInfo:null,
        userCountry: null,
        vModel: {
          Success: false,
          Title: null,
          Message: null,
          TransactionDetail: {}
        }
      };
    },
    methods: {


    }
};
</script>
<style scoped>
.web-application .sidebar{
    height:35em;
}
</style>